<template>

<div>
  <div class="card" qid="processing-role-section" id="update_processing_role">
    <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
      <div class="row mb-2">
        <div class="col-sm-6">
          <div qid="processing-role-table-title" class="float-left">
            <h5 v-if="!showOnTask" class="mb-2">
              {{ $t('activities.processing_role.title') }}
            </h5>
            <span v-if="!showOnTask" class="mb-2">
              <span class="cursor-pointer task-label-open mr-2"
                    v-if="getTask('update_processing_role')"
              >
                <UpdateSingleTaskModal
                    :task="getTask('update_processing_role')"
                    @reloadContent="reloadContent"
                    :editIcon="true"
                ></UpdateSingleTaskModal>
              </span>
              <span v-if="getGuide('update_processing_role')">
                <GuideButton :guide="getGuide('update_processing_role')"></GuideButton>
              </span>
            </span>
          </div>

        </div>
        <div class="col-sm-6">
          <div class="float-right btn btn-success"
               @click="showFormFunction"
               qid="processing-role-edit-button"
               v-if="!showForm && isGranted([permissions.ACTIVITY_EDIT, permissions.ACTIVITY_EDIT_OWN], activity)"
          >
            <font-awesome-icon icon="pen"/> {{ $t('system.edit') }}
          </div>
        </div>

      </div>
      <div class="mw-600" v-if="showForm">
        <multiselect
            v-model="processingRole"
            :options="options"
            :placeholder="$t('activities.processing_role.pr_placeholder')"
            label="name"
            :select-label="$t('system.dropdown_select_label')"
            :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')"
            track-by="name"
            class="mw-300 float-left"
            qid="processing-role-dropdown"
        >
          <template slot="option" slot-scope="props">
            <span v-if="props.option.value == 'Data processor'">
              <font-awesome-icon icon="microchip" class="mr-2"/>
            </span>
            <span v-if="props.option.value == 'Data controller'">
              <font-awesome-icon icon="joystick" class="mr-2"/>
            </span>
            <span v-if="props.option.value == 'Joint controller'">
              <font-awesome-icon icon="handshake" class="mr-2"/>
            </span>
            {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
          </template>
          <template slot="singleLabel" slot-scope="props">
            <span v-if="props.option.value == 'Data processor'">
              <font-awesome-icon icon="microchip" class="mr-2"/>
            </span>
            <span v-if="props.option.value == 'Data controller'">
              <font-awesome-icon icon="joystick" class="mr-2"/>
            </span>
            <span v-if="props.option.value == 'Joint controller'">
              <font-awesome-icon icon="handshake" class="mr-2"/>
            </span>
            {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
          </template>
        </multiselect>
        <div class="float-left">
          <b-button class="ml-3"
                    variant="secondary"
                    @click="cancelForm"
                    qid="edit-pr-cancel-button"
          >
            {{ $t('activities.processing_type.cancel') }}
          </b-button>
          <b-button class="ml-2"
                    variant="success"
                    @click="formSubmit"
                    qid="edit-pr-submit-button"
          >
            {{ $t('activities.processing_type.submit') }}
          </b-button>
        </div>
      </div>
      <div v-if="!showForm">
        <div v-if="activity.gdpr && activity.gdpr.processing_role" class="mt-2 section-container text-normal">
          <span qid="processing-role-name">
            <span v-if="activity.gdpr.processing_role == 'Data processor'">
              <font-awesome-icon icon="microchip" class="mr-2"/>
            </span>
            <span v-if="activity.gdpr.processing_role == 'Data controller'">
              <font-awesome-icon icon="joystick" class="mr-2"/>
            </span>
            <span v-if="activity.gdpr.processing_role == 'Joint controller'">
              <font-awesome-icon icon="handshake" class="mr-2"/>
            </span>
            {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(activity.gdpr.processing_role)) }}
          </span>
        </div>
        <p v-if="!activity.gdpr.processing_role" class="text-muted section-container">
          {{ $t('system.missing_input') }}
        </p>
      </div>
    </div>
  </div>
</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'ProcessingRole',
    data: function() {
      return {
        form: {},
        error: '',
        loadingItems: false,
        showForm: false,
        activity: {},
        processingRole: [],
        options: [
          { name: this.$t('activities.processing_role.data_processor_label'), value: 'Data processor' },
          { name: this.$t('activities.processing_role.data_controller_label'), value: 'Data controller' },
          { name: this.$t('activities.processing_role.joint_controller_label'), value: 'Joint controller' }
        ],
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object
      },
      showOnTask: {},
      task: {}
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    components: {
      UpdateSingleTaskModal,
      GuideButton
    },
    watch: {
      object: function (value) {
        this.activity = value
        this.setDefaultForm(value)
        this.loadTasks('update_processing_role');
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.activity.id && this.$store.state.updatedObject.who_am_i == this.activity.who_am_i) {
              this.activity = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_processing_role')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadActivity()
        this.loadTasks('update_processing_role')
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.activity.who_am_i,
              model_id: this.activity.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Activity' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Activity',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      formSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.form.processing_role = this.processingRole ? this.processingRole.value : '';

        piincHttp.put('activities/' + this.activity.slug, this.form).then(function(response) {
          self.activity = response.data
          self.$emit('updated');
          self.showForm = false;
          self.loadTasks('update_processing_role');
          self.$toastr('success', self.$t('activities.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      cancelForm() {
        this.showForm = false
      },
      showFormFunction() {
        let self = this
        this.processingRole = []
        if (this.activity.gdpr.processing_role) {
          this.processingRole = _.find(this.options, function(item) {
            return item.value === self.activity.gdpr.processing_role;
          });
        }
        this.showForm = true
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      loadActivity() {
        let self = this;
        piincHttp.get('activities/' + this.activity.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.activity = response.data;
        }, function() {});
      },
      setDefaultForm(object) {
        let self = this
        this.processingRole = []
        if (this.activity.gdpr.processing_role) {
          this.processingRole = _.find(this.options, function(item) {
            return item.value === self.activity.gdpr.processing_role;
          });
        }
      }
    },
    created () {
      this.activity = this.object
      if (this.activity && this.activity.slug) {
        this.loadTasks('update_processing_role');
      }
      this.setDefaultForm(this.activity)
      this.loadGuides('update_processing_role');

    }
  }
</script>
